/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_portfolio_builder_asset_list_filter_ExportAssetListsFilters = {
    file_type: b2b_v1_portfolio_builder_asset_list_filter_ExportAssetListsFilters.file_type;
    organization: string;
};
export namespace b2b_v1_portfolio_builder_asset_list_filter_ExportAssetListsFilters {
    export enum file_type {
        XLSX = 'xlsx',
        CSV = 'csv',
    }
}

